import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Programdtls from '../MenserviceProgram/Programdtls'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Corporate Program" />
                <Programdtls />
                <Footer />
            </div>

        </>
    )
}

export default Main